import React, { FC } from 'react'
import styles from 'styles/components/button.module.scss'

type Props = {
  dataCy?: string
  disabled?: boolean
  label: string
  onClick: () => void
  size: 'xsmall' | 'small' | 'medium' | 'large'
  type: 'outlined'
}

const GreyButton: FC<Props> = React.memo((props) => {
  const { dataCy, disabled, label, onClick, size, type } = props

  const sizeStyle = (() => {
    switch (size) {
      case 'xsmall':
        return styles.button_xsmall
      case 'small':
        return styles.button_small
      case 'medium':
        return styles.button_medium
      case 'large':
        return styles.button_large
      default:
        return styles.button_medium
    }
  })()

  const colorStyle = (() => {
    switch (type) {
      case 'outlined':
        return styles.button_grey_outlined
      default:
        return styles.button_grey_outlined
    }
  })()

  const className = disabled ? `${sizeStyle} ${styles.button_grey_disabled}` : `${sizeStyle} ${colorStyle}`

  const dataCyStr = dataCy ? `grey-button-from-${dataCy}` : 'grey-button'

  return (
    <button className={className} data-cy={dataCyStr} disabled={disabled} onClick={onClick}>
      {label}
    </button>
  )
})

export default GreyButton
